import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateGraphic,
  EmptyStateTitle,
  Spinner,
} from '@customerio/pluma-components/react';

export function CollectionImportingState() {
  return (
    <EmptyState>
      <EmptyStateGraphic>
        <Spinner />
      </EmptyStateGraphic>
      <EmptyStateTitle>Importing</EmptyStateTitle>
      <EmptyStateDescription>
        Your file is being imported, which may take a few minutes. You can leave this page while it finishes.
      </EmptyStateDescription>
    </EmptyState>
  );
}
